import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import ShipFromColumn from '../../../components/columns/ship-from-column';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const ShipFromColumnContainer = ({ fulfillmentId }) => {
  const { labelFulfillment } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  const { shipFromId } = labelFulfillment;

  return <ShipFromColumn shipFromId={shipFromId} />;
};

ShipFromColumnContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const ShipFrom = {
  getMessageDescriptor: () => messages.shipFrom,
  id: 'shipFrom',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <ShipFromColumnContainer fulfillmentId={data.id} />;
  },
};
